import { useQuery } from 'data-fetching-client';
import { GET_CTA_BY_PLACEMENT_GUID, GET_PLACEMENT_BY_CTA_GUID } from 'flow-doctor-lib/queries/ContentQueries';
const useCTAByGuid = ({
  portalId,
  guid,
  isPlacement
}) => {
  const {
    data: placementByCtaData,
    loading: ctaByPlacementLoading,
    error: ctaByPlacementError
  } = useQuery(GET_PLACEMENT_BY_CTA_GUID, {
    variables: {
      portalId,
      ctaGuid: guid
    },
    skip: isPlacement
  });
  const placementGuid = isPlacement || !placementByCtaData ? guid : placementByCtaData.placementByGuid.find(mapping => mapping.cta_guid === guid).placement_guid;
  const {
    data: placementData,
    loading: placementLoading,
    error: placementError
  } = useQuery(GET_CTA_BY_PLACEMENT_GUID, {
    variables: {
      portalId,
      placementGuid
    },
    skip: !isPlacement && !placementByCtaData
  });
  const dataToReturn = placementData ? placementData.ctaByPlacementGuid.find(placement => placement.guid === placementGuid) : null;
  return {
    data: dataToReturn,
    loading: ctaByPlacementLoading || placementLoading,
    error: ctaByPlacementError || placementError
  };
};
export default useCTAByGuid;